import { Controller, useFormContext } from "react-hook-form";
import { Radio, FormControlLabel, RadioProps, useTheme } from "@mui/material";
// import { Controller, useFormContext } from "react-hook-form";

interface RHFRadioSingleProps extends RadioProps {
  name: string;
  label: string;
  value: string;
}

export function RHFRadioSingle({
  name,
  label,
  value,
  ...radioProps
}: RHFRadioSingleProps) {
  const theme = useTheme();
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <Radio
              {...radioProps}
              checked={field.value === value}
              onChange={() => field.onChange(value)}
              sx={{
                color: theme.palette.primary.main,
                "&.Mui-checked": { color: theme.palette.primary.main },
              }}
            />
          }
          label={label}
        />
      )}
    />
  );
}
